export const SUBCAT_FETCH_REQUEST = "SUBCAT_FETCH_REQUEST";
export const SUBCAT_FETCH_SUCCESS = "SUBCAT_FETCH_SUCCESS";
export const SUBCAT_FETCH_FAILS = "SUBCAT_FETCH_FAILS";

export const SUBCAT_DELETE_REQUEST = "SUBCAT_DELETE_REQUEST";
export const SUBCAT_DELETE_SUCCESS = "SUBCAT_DELETE_SUCCESS";
export const SUBCAT_DELETE_FAILS = "SUBCAT_DELETE_FAILS";
export const SUBCAT_DELETE_RESET = "SUBCAT_DELETE_RESET";

export const SUBCAT_UPDATE_REQUEST = "SUBCAT_UPDATE_REQUEST";
export const SUBCAT_UPDATE_SUCCESS = "SUBCAT_UPDATE_SUCCESS";
export const SUBCAT_UPDATE_FAILS = "SUBCAT_UPDATE_FAILS";
export const SUBCAT_UPDATE_RESET = "SUBCAT_UPDATE_RESET";

export const SUBCAT_CREATE_REQUEST = "SUBCAT_CREATE_REQUEST";
export const SUBCAT_CREATE_SUCCESS = "SUBCAT_CREATE_SUCCESS";
export const SUBCAT_CREATE_FAILS = "SUBCAT_CREATE_FAILS";
export const SUBCAT_CREATE_RESET = "SUBCAT_CREATE_RESET";
